import 'crimson-tide/dist/styles/oira-styles.css'

import './styles.css'

import LightNav from 'crimson-tide/dist/Navigation/LightNav'
import React from 'react'
import Auth from '../Auth'

function Layout({ children }) {
  return (
    <>
      <LightNav maxWidth="100%">
        <h1
          style={{
            color: '#222',
            fontSize: '1.5em',
            fontWeight: '600',
            marginRight: '1.1em',
          }}
        >
          Admissions Data
        </h1>
        <Auth />
      </LightNav>
      <div className="grid-container">{children}</div>
    </>
  )
}

export default Layout
